import React from "react";
import RoadmapLarge from "../../RoadmapLarge/m27";
import { IV2RoadmapProps } from "@/types/V2RoadmapTypes";

export default class M27 extends React.Component<IV2RoadmapProps> {
	render() {
		const p = this.props;
		// console.log("M27 RS p", p);
 
		return (
			<RoadmapLarge
				pcode={p.pcode}
				mobile={p.mobile}
				history={p.history}
				historyBlink={p.historyBlink}
				lobbyMobile={p.lobbyMobile}
				type={"big-road"}
				small={true} />
		); 
	}
}